import { useMutation, useQueryClient } from '@tanstack/vue-query'
import { useCustomizationApi } from './use-customization'

export function useCreateCustomPrompt() {
  const queryClient = useQueryClient()
  const { createCustomPrompt } = useCustomizationApi()
  return useMutation({
    mutationFn: ({ title, content, specialty, isActive, creationMethod }) => {
      return createCustomPrompt({
        title,
        content,
        specialty,
        isActive,
        creationMethod,
      })
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['custom-prompts-list'] })
      queryClient.invalidateQueries({ queryKey: ['custom-prompts-table'] })
    },
  })
}

export function useUpdateCustomPrompt() {
  const queryClient = useQueryClient()
  const { updateCustomPrompt } = useCustomizationApi()
  return useMutation({
    mutationFn: ({ id, title, content, specialty, isActive, from }) => {
      return updateCustomPrompt({ id, title, content, specialty, isActive })
    },
    onMutate: async (variables, context, mutation) => {
      await queryClient.cancelQueries({
        queryKey: [variables.from || 'custom-prompts-table'],
      })
      const querydata = queryClient.getQueriesData({
        queryKey: [variables.from || 'custom-prompts-table'],
        type: 'active',
      })[0][0]
      const previousData = queryClient.getQueryData(querydata)
      queryClient.setQueryData(querydata, (oldData) => {
        const newData = {
          ...oldData,
          items: oldData.items.map((item) => {
            if (item.id === variables.id) {
              return { ...item, ...variables }
            }
            return item
          }),
        }
        return newData
      })
      return { previousData, querydata }
    },
    onError: (error, variables, context) => {
      console.log('error', error)
      queryClient.setQueryData(context.querydata, context.previousData)
    },
    onSettled: async (data, error, variables) => {
      await queryClient.invalidateQueries({
        queryKey: [
          variables.from === 'custom-prompts-list'
            ? 'custom-prompts-table'
            : 'custom-prompts-list',
        ],
      })
    },
  })
}

export function useDeactivateCustomPrompt() {
  const queryClient = useQueryClient()
  const { deactivateCustomPrompt } = useCustomizationApi()
  return useMutation({
    mutationFn: ({ id, from }) => {
      return deactivateCustomPrompt({ id })
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['custom-prompts-list'] })
      queryClient.invalidateQueries({ queryKey: ['custom-prompts-table'] })
    },
  })
}

export function useGenerateCustomMarkdown() {
  const { generateCustomMarkdown } = useCustomizationApi()
  return useMutation({
    mutationFn: ({ instructions }) => {
      return generateCustomMarkdown({ instructions })
    },
  })
}
